import { gql } from '@apollo/client'
import { Fragments } from '../fragments'

export const fetchUserContextQuery = gql`
  query FetchUserContext {
    self {
      id
      name
      email
      isClockedIn
      userType
      autoStationAssignmentEnabled
      permissions {
        canViewAdminPage
        canViewFirmSecrets
        canModifyLeasingSpecials
        canModifyNotes
        canViewSuperDashboard
        canViewSuperTaskDetails
        canViewCoreTaskInfo
        canViewCalEventUrls
        canCreateTask
        canViewBotAction
        canEditAgents
        canRunBasicJobs
        canViewOccupancy
        canEditTaskDetails
        canViewUnitsAndMarketing
        canResendTcpaViolations
        canResendMassCancellationViolations
        canResendAllowedActionViolations
        canResendInvalidBodyViolations
        canRemoveShiftAssignment
        canModifyOperatorShifts
        canModifySeniorOperatorShifts
      }
      unarchivedThreads {
        id
        isArchived
        lastReadMessageId
        lastInboundMessageId
      }
      lookingAtUser {
        id
        name
      }
      activeOperatorShift {
        id
        shift {
          id
          timeStart
          timeEnd
        }
      }
      mostRecentClockEvent {
        id
        clockInTime
        clockOutTime
      }
    }
  }
`

export const fetchInboxQuery = gql`
  query FetchInbox(
    $threadId: Int!
    $taskId: Int!
    $contactId: Int!
    $hasThreadId: Boolean!
    $hasTaskIdAndContactId: Boolean!
  ) {
    self {
      id
      unarchivedThreads {
        ...ThreadListItem
      }
    }

    # A later query, FetchThread, clears the blue dot by updating the last-read message.
    # This query just loads header information to display in sidebar, and should NOT clear the dot.
    thread(threadId: $threadId, updateLastRead: false) @include(if: $hasThreadId) {
      ...ThreadListItem
      leasingTask {
        ...ThreadLeasingTask
      }
    }

    # for redirecting from /inbox/threads/<task-id>/<contact-id> to /inbox/threads/<thread-id>
    contactThread(taskId: $taskId, contactId: $contactId) @include(if: $hasTaskIdAndContactId) {
      id
    }
  }

  ${Fragments.threadListItem}
  ${Fragments.threadLeasingTask}
`

export const fetchTasksPageQuery = gql`
  query FetchTasksPage(
    $threadId: Int!
    $taskId: Int!
    $contactId: Int!
    $hasThreadId: Boolean!
    $hasTaskId: Boolean!
    $hasTaskIdAndContactId: Boolean!
  ) {
    allFirmTasks {
      ...TaskListItem
    }

    # A later query, FetchThread, clears the blue dot by updating the last-read message.
    # This query just loads header information to display in sidebar, and should NOT clear the dot.
    thread(threadId: $threadId, updateLastRead: false) @include(if: $hasThreadId) {
      ...ThreadListItem
      leasingTask {
        ...ThreadLeasingTask
        ...TaskListItem
        holidays
      }
    }

    task(taskId: $taskId) @include(if: $hasTaskId) {
      ...TaskListItem
      ...TaskDetail
      holidays
    }

    # for redirecting from /inbox/tasks/threads/<task-id>/<contact-id> to /inbox/tasks/threads/<thread-id>
    contactThread(taskId: $taskId, contactId: $contactId) @include(if: $hasTaskIdAndContactId) {
      id
    }
  }

  ${Fragments.threadListItem}
  ${Fragments.threadLeasingTask}
  ${Fragments.taskListItem}
  ${Fragments.taskDetail}
`
